import React, {useEffect, useState} from 'react';
import "./callAssets.css"
import Grid from "@material-ui/core/Grid";
import MoreImage from "../../moreImage/moreImage";
import SelectImage from "../selectImage/selectImage";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Api from "../../../utils/api";
import {toast} from "react-toastify";

const CallAssets = ({supplementary}) => {
    const [selectedList , setSelectedList] = useState([])
    const [loading , setLoading] = useState(false)
    const [data , setData] = useState([])
    const handleChange = (e) => {
        setSelectedList(prev => ([...prev , e]))
    }

    useEffect(() => {
        new Api().get('/insurance/damage/video-call/recordings/list')
            .then((response) => {
            setData(response)

        })
    } ,[])

    const handleSendData = (id) => {
        setLoading(true)
        let object = {
            "form": "assign_file_to_supplementary",
            "file_id": selectedList,
            "damage_supp_id": id
        }

        new Api().post('/fileManager/damage/assign-file-to-supplementary', object).then((response) => {
            toast.success("ok")
            setLoading(false)

        })
    }


    return (
        <div className={"callAssets"}>
            <Grid container={true} xs={12}>
                {
                    data?.map((item) => {
                        return(
                            <Grid item xs={2}>
                                <SelectImage
                                    item={item}
                                    onChange={handleChange}
                                />
                            </Grid>
                        )
                    })
                }

            </Grid>
            <Grid container={true} xs={12}>
                <ButtonGroup className={"btns-row"}
                             aria-label="outlined primary button group">
                    {
                        supplementary?.map((item) => {
                            if(item.guilty === 1){
                                return (
                                    <Button disabled={loading} onClick={() => {handleSendData(item.id)}}  variant="contained"
                                            color={"default"}>
                                        {"افزودن به پرونده مقصر"}
                                    </Button>
                                )
                            }
                        })
                    }
                    {
                        supplementary?.map((item) => {
                            if(item.guilty === 0){
                                return (
                                    <Button disabled={loading}  onClick={() => {handleSendData(item.id)}}  variant="contained"
                                            color={"default"}>
                                        {"افزودن به پرونده زیان دیده" }
                                    </Button>
                                )
                            }
                        })
                    }

                </ButtonGroup>
            </Grid>
        </div>
    );
};

export default CallAssets;
